import { useEffect, useState } from "react";
import CreateStudentHelp from "./studentHelpCreate";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import {
  getStudentHelps,
  getStudentHelp,
  deleteStudentHelp,
} from "../../../../../action/masters/studentHelpActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  IStudentHelpIndex,
  IStudentHelpData,
} from "../../../../../models/master/studentHelp";
import { setStudentHelps } from "../../../../../store/slices/master/studentHelpSlice";
import StudentHelpEdit from "./studentHelpEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";

const StudentHelpIndex = (props: IStudentHelpIndex) => {
  const {
    getStudentHelps,
    studentHelps,
    getStudentHelp,
    studentHelp,
    deleteStudentHelp,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true)
    try {
      await getStudentHelp(id);
    } finally {
      setIsEditLoading(false)
    }
  };

  const getAllStudentHelps = async () => {
    setIsLoading(true);
    try {
      await getStudentHelps();
    } finally {
      setIsLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteStudentHelp(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllStudentHelps();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  useEffect(() => {
    getAllStudentHelps();
    return () => {
      dispatch(setStudentHelps([]));
    };
  }, []);
  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Student Help</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : studentHelps && studentHelps.length > 0 ? (
            studentHelps.map((studentHelp: IStudentHelpData) => {
              return (
                <li className="admin-card">
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(studentHelp.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(studentHelp.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={studentHelp.url} target="_blank">
                    <div className="btm">
                      <div className="img">
                        <img
                          src={
                            studentHelp.icon ? baseURL + studentHelp.icon : ""
                          }
                        />
                      </div>
                      <h2>{studentHelp.title}</h2>
                      <p>{studentHelp.description.slice(0, 30)}</p>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <CreateStudentHelp
          setShowCreate={handleCreateClose}
          getAllStudentHelps={() => getAllStudentHelps()}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
        >
          <StudentHelpEdit
            setShowEdit={handleEditClose}
            getAllStudentHelps={() => getAllStudentHelps()}
            studentHelp={studentHelp}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getStudentHelps: () => getStudentHelps(),
  getStudentHelp: (id: number) => getStudentHelp(id),
  deleteStudentHelp: (id: number, callBack: Function) =>
    deleteStudentHelp(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    studentHelps: state.studentHelp.studentHelps,
    studentHelp: state.studentHelp.studentHelp,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentHelpIndex);
